export const ACTION_TYPES = {
  SET_SELECTED_OFFER: 'offer/SET_SELECTED_OFFER',
  INIT_HAS_FETCHED_OFFER: 'offer/INIT_HAS_FETCHED_OFFER',
  OPEN_PAGE_MARKETING: 'offer/SET_PAGE_MARKETING',
  HIDE_PAGE_MARKETING: 'offer/HIDE_PAGE_MARKETING',
  SET_DOC_URL: 'offer/SET_DOC_URL',
  SET_ERROR: 'offer/SET_ERROR',
  INITIALIZE_INSUREDGOODS: 'insuredGood/INITIALIZE_INSUREDGOODS',
  UPDATE_INSUREDGOOD: 'insuredGood/UPDATE_INSUREDGOOD',
  UPDATE_INSUREDGOOD_AMOUNT: 'insuredGood/UPDATE_INSUREDGOOD_AMOUNT',
  UPDATE_INSUREDGOODS_PURCHASE_DATE: 'insuredGood/UPDATE_INSUREDGOODS_PURCHASE_DATE',
  UPDATE_PAYMENT_ERROR: 'insuredGood/UPDATE_PAYMENT_ERROR',
  SET_EMAIL_SENDED: 'email/SET_EMAIL_SENDED'
};
